import React, {Component} from 'react'
import moment from "moment"
import { getTotalItemStatisticsV2 } from "../../services/api/apiNextBox"
import changeNumberFormat from "../helpers/changeNumberFormat"
import { DatePicker } from 'antd'
class StatisticsByDays extends Component {
    state = {
        stats: [],
        loading: false,
        error: '',
        date:''
    }

    _onChangeDate = (value) => {
        const dateValue = value ? moment(value).format('YYYY-MM-DD') : ""
        this.setState({ ... this.state, date: dateValue },
            () => { this._fetchTotalItemStatistics() }
        )
    }

    componentDidMount() {
        this._fetchTotalItemStatistics()
    }

    _fetchTotalItemStatistics = async () => {
        if (this.state.loading) return true

        this.setState({
            loading: true,
            error: ''
        })
        const { date } = this.state
        const payload = {}
        if (date) { payload.date = date }

        try {
            const { success, data, message } = await getTotalItemStatisticsV2(payload)

            if (!success) {
                throw new Error(message)
            }

            this.setState({
                stats: Array.isArray(data) ? data : [],
                loading: false,
                error: ''
            })
        } catch (e) {
            this.setState({
                loading: false,
                error: e.message,
            })
        }
    }

    render() {
        const {stats} = this.state
        const totalProducts = stats.length

        return (
            <div className="StatisticsByDays">
                <h3>Tổng sản phẩm theo ngày</h3>
                <DatePicker
                    style={{ width: '100%', height: '2.25003rem', borderRadius: '0.1875rem' }}
                    className='mb-3 form-control'
                    format={'YYYY-MM-DD'}
                    disabledDate={current =>
                        moment().add(-1, "year") >= current ||
                        moment().add(0, "day") <= current
                    }
                    onChange={this._onChangeDate}
                    placeholder='Chọn ngày'
                />
                <div className="d-flex align-content-center justify-content-between">
                    {totalProducts > 0 ? (
                        <div className="total mt-2 mb-2 mr-3">Tổng số
                            <strong className='ml-1 mr-1'>
                                {changeNumberFormat(totalProducts)}
                            </strong>
                            sản phẩm</div>) :
                        <div className="total mt-2 mb-2">Tổng số 0 sản phẩm</div>
                    }
                </div>
                <table className="table border">
                    <thead>
                    <tr>
                        <th>#</th>
                        <th>Thứ</th>
                        <th>Ngày</th>
                        <th>Tổng hàng</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        stats.map((stat, index) => {
                            const {_id, count} = Object.assign({}, stat)
                            const m = moment(_id, 'DD-MM-YYYY').format('dddd')

                            return (
                                <tr key={_id}>
                                    <td>{index + 1}</td>
                                    <td>{m}</td>
                                    <td>{_id}</td>
                                    <td>{changeNumberFormat(count)}</td>
                                </tr>
                            )
                        })
                    }
                    </tbody>
                </table>
            </div>
        )
    }
}

export default StatisticsByDays
